
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSwitch, AppButton } from '@/components';
import { useSurpriseCategoryAdd } from '@/modules/surprise/category/model/add';
import { ROUTE_NAME_SURPRISE } from '@/modules/surprise/router';

export default defineComponent({
    name: ROUTE_NAME_SURPRISE.CATEGORY.ADD,
    components: { AppFormRow, AppInput, AppCard, AppSwitch, AppButton },
    setup() {
        const { model, v$, create } = useSurpriseCategoryAdd();

        return { v$, model, create };
    }
});
